import React, { useState, useEffect } from 'react'
import OutstationForm from './OutstationForm'
import LocalForm from './LocalForm'
import RentalForm from './RentalForm'
import RecentSearchChips from './RecentSearchChips'
import { slugify } from '../../../../utils/slugify'

const TAB_MAP = { 1: 'local', 2: 'rental', 3: 'outstation' }

const Form = ({ routePrefill }) => {
    const [type, setType] = useState("outstation")
    const [chipPrefill, setChipPrefill] = useState(null)
    // For outstation chips, override the routePrefill prop
    const [routePrefillOverride, setRoutePrefillOverride] = useState(null)

    useEffect(() => {
        if (routePrefill?.fromCity && routePrefill?.toCity) {
            setType("outstation")
            // clear any chip override so the real routePrefill takes effect
            setRoutePrefillOverride(null)
            setChipPrefill(null)
        }
    }, [routePrefill])

    const changeType = (value) => {
        setType(value)
        // Clear chip prefill when user manually switches tabs
        setChipPrefill(null)
        setRoutePrefillOverride(null)
    }

    const handleChipSelect = (trip) => {
        const tab = TAB_MAP[trip.trip_type] || 'outstation'
        setType(tab)

        if (trip.trip_type === 3) {
            // Outstation: pass as routePrefill format (OutstationForm handles it natively)
            setRoutePrefillOverride({
                fromCity: slugify(trip.fromCity),
                toCity: slugify(trip.toCity),
            })
            setChipPrefill(null)
        } else {
            // Local / Rental: pass as chipPrefill prop
            setChipPrefill(trip)
            setRoutePrefillOverride(null)
        }
    }

    const effectiveRoutePrefill = routePrefillOverride || routePrefill

    return (
        <div className='form'>
            <div className='form__options'>
                <div className={type==='outstation'?'form__option--active':'form__option'} onClick={()=>{changeType('outstation')}}>
                    <svg className='form__option-icon' aria-hidden="true">
                        <use href="/sprite.svg#icon-outstation"></use>
                    </svg>
                    <span className='form__option-text'>OutStation</span>
                </div>
                <div className={type==='rental'?'form__option--active':'form__option'} onClick={()=>{changeType('rental')}}>
                    <svg className='form__option-icon' aria-hidden="true">
                        <use href="/sprite.svg#icon-rental"></use>
                    </svg>
                    <span className='form__option-text'>Rental</span>
                </div>
                <div className={type==='local'?'form__option--active':'form__option'} onClick={()=>{changeType('local')}}>
                    <svg className='form__option-icon' aria-hidden="true">
                        <use href="/sprite.svg#icon-local"></use>
                    </svg>
                    <span className='form__option-text'>Local</span>
                </div>
            </div>
            {type==='outstation' && <OutstationForm routePrefill={effectiveRoutePrefill} />}
            {type==='local' && <LocalForm chipPrefill={chipPrefill} />}
            {type==='rental' && <RentalForm chipPrefill={chipPrefill} />}
            <RecentSearchChips onSelect={handleChipSelect} />
        </div>
    )
}

export default Form